import { ShiftPublishState } from '@frontend/graphql/types.generated'

import { coverState } from '../roster_board/rosterCoverage'
import { isLiveToVolunteers } from '../shifts/publishState'
import type { ShiftWithSlots } from '../shifts/types'

import type { RosterFilters } from './types'

const matchesRoles = (shift: ShiftWithSlots, { roles }: RosterFilters): boolean =>
  roles.length === 0 || roles.includes(shift.roleName)

const matchesStatus = (shift: ShiftWithSlots, { status }: RosterFilters): boolean => {
  if (status === 'draft') return shift.publishState === ShiftPublishState.Draft
  if (status === 'published') return isLiveToVolunteers(shift)
  return true
}

const matchesCoverage = (shift: ShiftWithSlots, { coverage }: RosterFilters): boolean => {
  if (coverage === 'any') return true
  const state = coverState(shift.shiftSlots.assignedCount, shift.shiftSlots.totalCount)
  return coverage === 'full' ? state === 'full' : state !== 'full'
}

const matchesPeople = (shift: ShiftWithSlots, { people }: RosterFilters): boolean =>
  people.length === 0 ||
  shift.shiftSlots.nodes.some((slot) => slot.supporter && people.includes(slot.supporter.id))

export const shiftMatchesFilters = (shift: ShiftWithSlots, filters: RosterFilters): boolean =>
  matchesRoles(shift, filters) &&
  matchesStatus(shift, filters) &&
  matchesCoverage(shift, filters) &&
  matchesPeople(shift, filters)

export const filterShifts = (shifts: ShiftWithSlots[], filters: RosterFilters): ShiftWithSlots[] =>
  shifts.filter((shift) => shiftMatchesFilters(shift, filters))
